import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import {Bar} from "surveylabJsAssets/chart/plugin/bar";

export class MeansBar extends Bar {
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    height: 675,
                    width: 675,
                },
                plotOptions: {
                    bar: {
                        borderColor: '#000',
                    }
                },
                yAxis: {
                    min: 0,
                    max: 9,
                    tickInterval: 1,
                    allowDecimals: false,
                    // Force exact integer ticks 0..9 and prevent Highcharts from extending to 10
                    tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    startOnTick: true,
                    endOnTick: false,
                    // Prevent any auto-adjustment of the axis range regardless of data values
                    minRange: 9,
                    softMin: 0,
                    softMax: 9,
                    title: {
                        useHTML: false,
                        style: {
                            fontSize: '15px',
                            fontWeight: 'bold',
                        },
                        margin: 20,
                    },
                    plotBands: [
                        {
                            from: 0,
                            to: 2.5,
                            color: '#ffffff'
                        },
                        {
                            from: 2.5,
                            to: 4,
                            color: '#e7e6e6'
                        },
                        {
                            from: 4,
                            to: 6,
                            color: '#bfbfbf'
                        },
                        {
                            from: 6,
                            to: 7.5,
                            color: '#e7e6e6'
                        },
                        {
                            from: 7.5,
                            to: 9,
                            color: '#ffffff'
                        },
                    ],
                    plotLines: [
                        {
                            value: 4,
                            className: 'y-4-line',
                            zIndex: 1
                        },
                        {
                            value: 5,
                            className: 'y-5-line',
                            zIndex: 1
                        }
                    ]
                },
                xAxis: {
                    title: {
                        useHTML: false,
                        style: {
                            fontSize: '15px',
                            fontWeight: 'bold',
                        },
                        margin: 20,
                    },
                    labels: {
                        enabled: true,
                        useHTML: true,
                        style: {
                            fontSize: '13px',
                            whiteSpace: 'nowrap',
                            textOverflow: 'clip'
                        }
                    },
                    tickmarkPlacement: 'on',

                    // Insert gaps between factor groups
                    breaks: [
                        {from: 0, to: 1, breakSize: 1.5},
                        {from: 4, to: 5, breakSize: 1.5},
                        {from: 9, to: 10, breakSize: 1.5},
                    ],
                },

            }
        );
    }
}

export default function () {
    registerPlugin(MeansBar)
}
